import {
    getCartsDataView,
    getCartState,
    getCurrentCartState,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useCurrentCartState = convertSelectorToHook(getCurrentCartState);
export const useCurrentCart = () => useCurrentCartState().value;
export const useCartState = convertSelectorToHook(getCartState);
export const useCartsDataView = convertSelectorToHook(getCartsDataView);
export const useActiveCartState = (cartId: string | undefined) => {
    const idCartState = useCartState(cartId);
    const currentCartState = useCurrentCartState();
    return cartId ? idCartState : currentCartState;
};
